export const openLinkNewTab = (link: string) => {
  window.open(link, '_blank')?.focus();
}
